<template>
<b-row class="align-items-strech m-0 p-0" v-if="modeBoxOptions.title">
  <b-col v-for="(item, index) in items" :key="index" class="mb-1 p-2" :class="modeBoxOptions.boxCantFilas">
    <router-link :to="interpolatePath(item)">
      <div class="caja p-3 mr-1 sombra rounded h-100" :style="`border-top: ${modeBoxOptions.borderBox}px solid ${modeBoxOptions.colorAcentBox} !important; min-height: ${modeBoxOptions.minHeight}; justify-content: ${modeBoxOptions.justifyContent}; align-items: ${modeBoxOptions.alignItems}; padding-top: ${modeBoxOptions.paddingTop} !important`">
        <h5 class="text-muted my-0" :class="{ dnone: !text(item, modeBoxOptions.category) }"> {{ limitCharacters(text(item, modeBoxOptions.category), modeBoxOptions.cantCaractersCategory) }}</h5>
        <h3 class="text-secondary mb-0" :class="{ textCenter: modeBoxOptions.justifyContent === 'center', textRight: modeBoxOptions.alignItems === 'flex-end' }"> {{ limitCharacters(text(item, modeBoxOptions.title), modeBoxOptions.cantCaractersTitle) }}</h3>
        <div class="text-secondary content" :class="{ dnone: !text(item, modeBoxOptions.content) }">{{ limitCharacters(text(item, modeBoxOptions.content), modeBoxOptions.cantCaractersContent) }}</div>
      </div>
    </router-link>
  </b-col>
</b-row>
</template>

<script>
import _ from 'lodash'
import lmToasts from '@/mixins/lmToasts.js'
export default {
  name: 'Box',
  mixins: [lmToasts],
  data () {
    return {
      error: false,
      myToast: null
    }
  },
  props: {
    items: {
      type: [Array, String],
      default: () => [],
      required: true
    },
    modeBoxOptions: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  watch: {
    'modeBoxOptions.path': {
      immediate: false,
      deep: false,
      // Chequea que se escriben correctamente las propiedades en el path
      handler (val, oldVal) {
        // función que busca las coincidencias en los key
        var traverse = function (item, keys) {
          return keys.split('.').reduce(function (cur, key) {
            return cur[key]
          }, item)
        }
        // Saca las variables del path y los coloca en un array
        const path = this.modeBoxOptions.path
        // eslint-disable-next-line no-useless-escape
        const regExp = /[^{\}]+(?=})/g
        const match = path.match(regExp)

        // Hace un for por el array de variables
        // Si encuenta una variable que no existe, setea error a true
        let res = null
        _.forEach(match, (value, key) => {
          res = traverse(this.items[0], match[key])
          if (!res) {
            this.error = true
            return false
          } else {
            this.error = false
          }
        })
        // Si hay un error, muestra el toast de error, sino el de éxito
        // El setTimeout da tiempo al usuario que termine de escribir para dar el mensaje
        if (this.error) {
          clearTimeout(this.myToast)
          this.myToast = setTimeout(() => {
            this.lmToastDangerMessage('Lo sentimos pero ha referenciado propiedades que no pertenecen a este listado.', 'Error en variable de Ruta')
          }, 2000)
        } else {
          clearTimeout(this.myToast)
          this.myToast = setTimeout(() => {
            this.$bvToast.hide(1)
            this.lmToastSuccessMessage('Las propiedades son correctas.', 'Ruta')
          }, 2000)
        }
      }
    }
  },
  methods: {
    limitCharacters (value, cant) {
      if (value) {
        if (value.toString().length === value.toString().substring(0, cant).length) {
          return value.toString().substring(0, cant)
        } else {
          return value.toString().substring(0, cant) + ' ...'
        }
      }
    },
    // Interpola el path con las variables que vienen entre llaves.
    // Ej: remplaza {{role.id}} por el contenido de item.role.id
    interpolatePath (item) {
      try {
        _.templateSettings.interpolate = /{{([\s\S]+?)}}/g
        const template = _.template(this.modeBoxOptions.path)
        const compiled = template({ ...item })
        return compiled
      } catch (error) {
        // console.log('error', error)
        return ''
      }
    },
    // Chequea si el item es un objeto o un string
    // si es un texto retorna el string
    // si es un objeto retorna res?.name
    text (item, field) {
      let res = item[field]
      if (typeof res === 'object') {
        res = res?.name || ''
      }
      return res
    }
  }
}
</script>

<style scoped>
.caja {
  display: flex;
  flex-direction: column;
}

a {
  color: #6c757d;
}

a:hover {
  color: #6c757d;
}

.sombra {
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.23s ease-out;
}

.sombra:hover {
  box-shadow: 0 0.3rem 0.5rem rgba(0, 0, 0, 0.2);
}

.textCenter {
  text-align: center;
}

.textRight {
  text-align: right;
}

.content {
  margin-top: 10px;
}

.dnone {
  display: none;
}
</style>
